import {z as zod} from "zod";

export type OttokartCustomerEngagementWorkspaceCapabilityConfiguration = Record<string, never>;

/**
 * Coerce null/unknown DB payloads to {} so workspace bootstrap does not fail client validation.
 */
export const ottokartCustomerEngagementWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttokartCustomerEngagementWorkspaceCapabilityConfiguration> =
    zod.unknown().transform(() => {
        return {};
    });
